<template>
  <v-card>
    <v-toolbar
      class="white--text"
      color="indigo"
      style="position: sticky; top: 0px; z-index: 1"
      dense
    >
      <v-toolbar-title>Calendario settimanale</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_modifica = true;"
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary"> mdi-pencil </v-icon>
          </v-btn>
        </template>
        <span>Modifica</span>
      </v-tooltip> 
      <!-- Bottone di aggiunta -->
      <!-- <v-tooltip bottom v-if="bottoni">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_aggiungi_giorno = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi</span>
      </v-tooltip>
      <v-spacer></v-spacer> -->
      <!-- Bottone di chiusura -->
      <v-tooltip bottom v-if="bottoni">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5 mb-0 pb-5">
      <v-data-table
        height="40vh"
        :headers="headers"
        :items="lista_tabella"
        fixed-header
        class="elevation-1 pt-0"
      >
      </v-data-table>
    </v-card-text>
    <!-- DIALOG AGGIUNGI GIORNO -->
    <v-dialog v-model="dialog_aggiungi_giorno" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Aggiungi giorno</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiGiorno" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_aggiungi_giorno = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                :items="lista_giorni"
                label="Giorno"
                v-model="giorno"
              ></v-autocomplete
            ></v-col>
            <v-col cols="4"
              ><v-autocomplete
                :items="lista_ore"
                label="Dalle ore"
                v-model="ora_da"
              ></v-autocomplete
            ></v-col>
            <v-col cols="4"
              ><v-autocomplete
                :items="lista_ore"
                label="Alle ore"
                v-model="ora_a"
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-card-text>
        
      </v-card>
    </v-dialog>

    <!-- DIALOG NUOVO CALENDARIO -->
    <v-dialog v-model="dialog_modifica" width="700px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Modifica calendario </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="modificaCalendario" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Lunedì: </h3></v-col>
            <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[0].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[0].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Martedì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[1].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[1].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Mercoledì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[2].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[2].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Giovedì:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[3].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[3].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Venerdì:</h3></v-col>
            <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[4].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[4].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Sabato:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[5].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[5].ora_a"></v-text-field></v-col>
          </v-row>
          <v-row align="center" justify="center" style="height: 10vh">
            <v-col cols="4"> <h3>Domenica:</h3></v-col>
             <v-col cols="4"
              >
              <v-text-field type="time" placeholder="Dalle ore"
                class="mr-5" v-model="lista_tabella[6].ora_da"></v-text-field></v-col>
            <v-col cols="4"
              ><v-text-field type="time" placeholder="Alle ore"
                class="mr-5" v-model="lista_tabella[6].ora_a"></v-text-field></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>

import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: { SnackbarQV, },

  props: ["bottoni"],

  data() {
    return {
      // Variabili d'appoggio
      giorno: "",
      ora_da: null,
      ora_a: null,

      // Modal
      dialog_aggiungi_giorno: false,
      dialog_modifica: false,

      // Array
      lista_giorni: [
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
        "Domenica",
      ],
      lista_ore: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24,
      ],

      headers: [
        {
          text: "Giorno",
          value: "num_giorno",
        },
        {
          text: "Dalle ore",
          value: "ora_da",
        },
        {
          text: "Alle ore",
          value: "ora_a",
        },
      ],
      lista_tabella: [],
    };
  },

  computed: {},

  watch: {},

  methods: {
    aggiungiGiorno() {
      this.lista_tabella.push({
        giorno: this.giorno,
        ora_da: this.ora_da,
        ora_a: this.ora_a,
      });
      this.giorno = "";
      this.ora_da = null;
      this.ora_a = null;
      this.dialog_aggiungi_giorno = false;
    },

    clickChiudi() {
      this.$emit("click_chiudi");
    },

    getCalendario() {
      console.log("Get calendario dettaglio");
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getcalendariodettaglio",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.lista_tabella = res.data.calendario;

        this.lista_tabella.forEach((e) => {
          console.log(e.ora_da.split(':'));
          e.ora_da = e.ora_da.split(':')[0] + ":" + e.ora_da.split(':')[1];
          e.ora_a = e.ora_a.split(':')[0] + ":" + e.ora_a.split(':')[1];
          switch (e.num_giorno) {
            case 1:
              e.num_giorno = "Lunedì";
              break;
            case 2:
              e.num_giorno = "Martedì";
              break;
            case 3:
              e.num_giorno = "Mercoledì";
              break;
            case 4:
              e.num_giorno = "Giovedì";
              break;
            case 5:
              e.num_giorno = "Venerdì";
              break;
            case 6:
              e.num_giorno = "Sabato";
              break;
            case 7:
              e.num_giorno = "Domenica";
              break;
          }
        });

        console.log(this.lista_tabella);
      });
    },

    modificaCalendario() {

      this.lista_tabella.forEach((lt) =>{
        lt.ora_da = lt.ora_da + ":00"
        lt.ora_a = lt.ora_a + ":00"
      });

      const request = {
        controller: "Tools",
        method: "PUT",
        richiesta: {
          action: "setcalendariodettaglio",
          token: localStorage.getItem("user_token"),
          calendario: this.lista_tabella,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print(
            "success",
            `Salvataggio effettuato.`
          );

          this.getCalendario();
          this.dialog_modifica = false;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
  },

  created() {},

  mounted() {
    this.getCalendario();
  },
};
</script>

<style scoped>
</style>